import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const Details = (props) => {
  const { paymentMethodFormPayload } = props

  const {
    entityState: {
      processing_api,
      short_name,
      title,
    },
    errors,
    handlers,
  } = paymentMethodFormPayload

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.short_name} label="* Short Code" marginTop={['large', 0]}>
            <input name="short_name" type="text" value={short_name} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Processing API Code">
            <select name="processing_api" value={processing_api} {...handlers}>
              <option value="">Please Select...</option>
              <option value="campaign_agent_vpa_pay">CampaignAgent VPAPay</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Details.propTypes = {
  paymentMethodFormPayload: PropTypes.object.isRequired,
}

export default Details
